import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Skeleton, Stack, useTheme } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { GenericCenteredContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import {
  ProductPickerProduct,
  ProductStatus,
} from "@src/store/slices/productPicker/types";

export const ProductListStatus = ({
  data,
}: ICellRendererParams<ProductPickerProduct>) => {
  const theme = useTheme();
  const SkeletonColors = {
    Archived: theme.palette.text.interactive.neutral.disabled,
    Active: theme.igIconColors.success,
    Draft: theme.igIconColors.warning,
  };

  if (!data?.status) {
    return null;
  }

  const status = getStatus(data.status, theme);
  return (
    <GenericCenteredContainer>
      <Stack direction="row" spacing={2} alignItems="center">
        <Skeleton
          animation={false}
          variant={"circular"}
          sx={{
            width: "8px",
            height: "8px",
            backgroundColor: SkeletonColors[status.label],
          }}
        />
        <IgTypography variant={"body2"} color={theme.palette.text.secondary}>
          {status.label}
        </IgTypography>
      </Stack>
    </GenericCenteredContainer>
  );
};

function getStatus(status: ProductStatus, theme: Theme) {
  switch (status) {
    case ProductStatus.Active:
      return {
        type: "success",
        label: "Active",
        color: theme.igIconColors.success,
      } as const;
    case ProductStatus.Unlisted:
      return {
        type: "success",
        label: "Unlisted",
        color: theme.igIconColors.warning,
      } as const;
    case ProductStatus.Draft:
      return {
        type: "info",
        label: "Draft",
        color: theme.igIconColors.warning,
      } as const;
    case ProductStatus.Archived:
      return {
        type: "default",
        label: "Archived",
        color: theme.palette.text.interactive.neutral.disabled,
      } as const;
  }
}
